import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from "react-router-dom";
import {getLocalProducts, syncProducts, deleteProduct} from "../../redux/actions/local";
import Button from "../../components/CustomButton/CustomButton";
import Card from "../../components/Card/Card";
import { Table } from "react-bootstrap";

class Local extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            search: ''
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    componentDidMount() {
        this.props.getLocalProducts();
    }

    componentDidUpdate(prevProps) {
        const { message } = this.props;

        // Gestion des notifications
        if (message && (!prevProps.message || prevProps.message.timestamp !== message.timestamp)) {
            if (this.props.showNotification) {
                this.props.showNotification(message.message, message.status);
            }
        }
    }

    handlePageChange(page) {
        this.setState({ currentPage: page });
    }

    handleSearchChange(e) {
        this.setState({ search: e.target.value, currentPage: 1 });
    }

    getFilteredProducts() {
        const { products } = this.props;
        const { search } = this.state;

        if (!Array.isArray(products)) {
            return [];
        }

        if (!search) return products;

        const lower = search.toLowerCase();
        return products.filter(
            p => {
                const nom = p?.nom || '';
                return nom.toLowerCase().includes(lower);
            }
        );
    }

    renderProducts() {
        const { loading, products } = this.props;
        const { currentPage, search } = this.state;
        const filtered = this.getFilteredProducts();
        const pageSize = 25;
        const start = (currentPage - 1) * pageSize;
        const paginated = filtered.slice(start, start + pageSize);

        if (loading) {
            return (
                <tr>
                    <td colSpan={8} style={{ padding: '40px', textAlign: 'center' }}>
                        <i className="fa fa-spinner fa-spin" style={{ marginRight: '10px' }} />
                        Chargement des produits...
                    </td>
                </tr>
            );
        }

        if (paginated.length === 0) {
            let message = "Aucun produit disponible";
            if (search) {
                message = `Aucun produit trouvé pour "${search}"`;
            } else if (!Array.isArray(products) || products.length === 0) {
                message = "Aucun produit en local. Cliquez sur 'Synchroniser' pour télécharger les données.";
            }

            return (
                <tr>
                    <td colSpan={8} style={{ padding: '40px', textAlign: 'center' }}>
                        <div style={{ color: '#666' }}>
                            <i className="fa fa-info-circle" style={{ marginRight: '8px' }}></i>
                            {message}
                        </div>
                    </td>
                </tr>
            );
        }

        return paginated.map((prod, key) => (
            <tr key={prod._id || key} style={{
                borderBottom: '1px solid #e9ecef'
            }}>
                <td style={{
                    padding: '15px 20px',
                    fontSize: '14px',
                    fontWeight: '500',
                    textAlign: 'center'
                }}>
                    {start + key + 1}
                </td>
                <td style={{
                    padding: '15px 20px',
                    fontSize: '14px'
                }}>
                    {prod.familleTherapeutique || 'Non définie'}
                </td>
                <td style={{
                    padding: '15px 20px',
                    fontSize: '14px',
                    fontWeight: '500'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <i className="fa fa-pills" style={{ color: '#007bff', marginRight: '8px' }}></i>
                        {prod.nom || 'Nom non défini'}
                    </div>
                </td>
                <td style={{
                    padding: '15px 20px',
                    fontSize: '14px'
                }}>
                    {prod.DCI || 'Non défini'}
                </td>
                <td style={{
                    padding: '15px 20px',
                    fontSize: '14px'
                }}>
                    {prod.dosage || 'Non défini'}
                </td>
                <td style={{
                    padding: '15px 20px',
                    fontSize: '14px'
                }}>
                    {prod.forme || 'Non définie'}
                </td>
                <td style={{
                    padding: '15px 20px',
                    fontSize: '14px'
                }}>
                    {prod.conditionnement || 'Non défini'}
                </td>
                <td style={{ padding: '15px 20px', textAlign: 'center' }}>
                    <div style={{ display: 'flex', gap: '6px', justifyContent: 'center', alignItems: 'center' }}>
                        <Link to={`/app/product/detail/${prod._id}`}>
                            <Button
                                simple
                                bsStyle="info"
                                size="sm"
                                style={{
                                    padding: '6px 10px',
                                    fontSize: '12px',
                                    borderRadius: '6px',
                                    fontWeight: '500',
                                    minWidth: '60px'
                                }}
                            >
                                <i className="fa fa-eye" style={{ marginRight: '4px' }} />
                                Voir
                            </Button>
                        </Link>
                        <Link to={`/app/product/form/${prod._id}`}>
                            <Button
                                simple
                                bsStyle="warning"
                                size="sm"
                                style={{
                                    padding: '6px 10px',
                                    fontSize: '12px',
                                    borderRadius: '6px',
                                    fontWeight: '500',
                                    minWidth: '70px'
                                }}
                            >
                                <i className="fa fa-edit" style={{ marginRight: '4px' }} />
                                Modifier
                            </Button>
                        </Link>
                        <Button
                            simple
                            bsStyle="danger"
                            size="sm"
                            onClick={() => this.confirmDelete(prod)}
                            style={{
                                padding: '6px 10px',
                                fontSize: '12px',
                                borderRadius: '6px',
                                fontWeight: '500',
                                minWidth: '80px'
                            }}
                        >
                            <i className="fa fa-trash" style={{ marginRight: '4px' }} />
                            Supprimer
                        </Button>
                    </div>
                </td>
            </tr>
        ));
    }

    confirmDelete = (prod) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce produit ? Cette action est irréversible.')) {
            this.props.deleteProduct(prod);
        }
    };

    renderPagination() {
        const filtered = this.getFilteredProducts();
        const pageSize = 25;
        const totalPages = Math.ceil(filtered.length / pageSize);
        const { currentPage } = this.state;
        if (totalPages <= 1) return null;

        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px 0',
                gap: '15px'
            }}>
                <button
                    onClick={() => this.handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{
                        padding: '8px 16px',
                        border: '1px solid #dee2e6',
                        backgroundColor: 'white',
                        borderRadius: '4px',
                        cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                        fontSize: '14px'
                    }}
                >
                    <i className="fa fa-chevron-left"></i> Précédent
                </button>

                <span style={{
                    fontSize: '14px',
                    color: '#495057',
                    fontWeight: '500'
                }}>
                    Page {currentPage} sur {totalPages}
                </span>

                <button
                    onClick={() => this.handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    style={{
                        padding: '8px 16px',
                        border: '1px solid #dee2e6',
                        backgroundColor: 'white',
                        borderRadius: '4px',
                        cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                        fontSize: '14px'
                    }}
                >
                    Suivant <i className="fa fa-chevron-right"></i>
                </button>
            </div>
        );
    }

    render() {
        const { products, loading } = this.props;
        const { search } = this.state;
        const filtered = this.getFilteredProducts();

        return (
            <div style={{
                padding: '20px',
                backgroundColor: '#f8f9fa',
                minHeight: '100vh'
            }}>
                {/* En-tête de la section */}
                <div style={{
                    backgroundColor: 'white',
                    borderRadius: '15px',
                    padding: '25px',
                    marginBottom: '25px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                    border: '1px solid #e3f2fd'
                }}>
                    <div style={{ marginBottom: '20px' }}>
                        <h2 style={{
                            margin: '0 0 10px 0',
                            color: '#2c3e50',
                            fontSize: '28px',
                            fontWeight: '700'
                        }}>
                            <i className="fa fa-database" style={{ marginRight: '12px', color: '#007bff' }}></i>
                            Base de Données Locale
                        </h2>
                        <p style={{
                            color: '#6c757d',
                            margin: 0,
                            fontSize: '16px'
                        }}>
                            Gérez vos produits pharmaceutiques stockés localement
                        </p>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '15px'
                    }}>
                        <div style={{ flex: '1', minWidth: '250px' }}>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    placeholder="🔍 Rechercher par nom de produit..."
                                    value={search}
                                    onChange={this.handleSearchChange}
                                    className="form-control"
                                    style={{
                                        padding: '12px 20px',
                                        borderRadius: '25px',
                                        border: '2px solid #e3f2fd',
                                        fontSize: '14px',
                                        backgroundColor: '#fafafa'
                                    }}
                                />
                            </div>
                        </div>

                        <Button
                            bsStyle="primary"
                            disabled={loading}
                            onClick={() => this.props.syncProducts()}
                            style={{
                                padding: '12px 24px',
                                borderRadius: '25px',
                                fontWeight: '600',
                                fontSize: '14px',
                                minWidth: '180px'
                            }}
                        >
                            <i className={loading ? 'fa fa-refresh fa-spin' : 'fa fa-refresh'} style={{ marginRight: '8px' }} />
                            {loading ? 'Synchronisation...' : 'Synchroniser'}
                        </Button>
                    </div>

                    {Array.isArray(products) && products.length > 0 && (
                        <div style={{
                            marginTop: '15px',
                            padding: '10px 20px',
                            backgroundColor: '#e8f4fd',
                            borderRadius: '10px',
                            border: '1px solid #bbdefb'
                        }}>
                            <small style={{ color: '#1976d2', fontWeight: '500' }}>
                                <i className="fa fa-info-circle" style={{ marginRight: '6px' }}></i>
                                Total: {products.length} produit{products.length > 1 ? 's' : ''} en local
                            </small>
                        </div>
                    )}
                </div>

                {/* Tableau amélioré */}
                <Card
                    tableFullWidth
                    content={
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '15px',
                            overflow: 'hidden',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                        }}>
                            <Table hover responsive style={{ margin: 0 }}>
                                <thead style={{ backgroundColor: '#f8f9fa' }}>
                                    <tr>
                                        <th style={{
                                            padding: '18px 20px',
                                            fontSize: '14px',
                                            fontWeight: '700',
                                            color: '#495057',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            borderBottom: '2px solid #dee2e6',
                                            width: '60px',
                                            textAlign: 'center'
                                        }}>
                                            N°
                                        </th>
                                        <th style={{
                                            padding: '18px 20px',
                                            fontSize: '14px',
                                            fontWeight: '700',
                                            color: '#495057',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            borderBottom: '2px solid #dee2e6'
                                        }}>
                                            <i className="fa fa-tags" style={{ marginRight: '8px', color: '#007bff' }}></i>
                                            Famille
                                        </th>
                                        <th style={{
                                            padding: '18px 20px',
                                            fontSize: '14px',
                                            fontWeight: '700',
                                            color: '#495057',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            borderBottom: '2px solid #dee2e6'
                                        }}>
                                            <i className="fa fa-prescription-bottle" style={{ marginRight: '8px', color: '#007bff' }}></i>
                                            Nom commercial
                                        </th>
                                        <th style={{
                                            padding: '18px 20px',
                                            fontSize: '14px',
                                            fontWeight: '700',
                                            color: '#495057',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            borderBottom: '2px solid #dee2e6'
                                        }}>
                                            <i className="fa fa-flask" style={{ marginRight: '8px', color: '#007bff' }}></i>
                                            DCI
                                        </th>
                                        <th style={{
                                            padding: '18px 20px',
                                            fontSize: '14px',
                                            fontWeight: '700',
                                            color: '#495057',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            borderBottom: '2px solid #dee2e6'
                                        }}>
                                            <i className="fa fa-balance-scale" style={{ marginRight: '8px', color: '#007bff' }}></i>
                                            Dosage
                                        </th>
                                        <th style={{
                                            padding: '18px 20px',
                                            fontSize: '14px',
                                            fontWeight: '700',
                                            color: '#495057',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            borderBottom: '2px solid #dee2e6'
                                        }}>
                                            <i className="fa fa-capsules" style={{ marginRight: '8px', color: '#007bff' }}></i>
                                            Forme
                                        </th>
                                        <th style={{
                                            padding: '18px 20px',
                                            fontSize: '14px',
                                            fontWeight: '700',
                                            color: '#495057',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            borderBottom: '2px solid #dee2e6'
                                        }}>
                                            <i className="fa fa-box" style={{ marginRight: '8px', color: '#007bff' }}></i>
                                            Conditionnement
                                        </th>
                                        <th style={{
                                            padding: '18px 20px',
                                            fontSize: '14px',
                                            fontWeight: '700',
                                            color: '#495057',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            borderBottom: '2px solid #dee2e6',
                                            width: '250px',
                                            textAlign: 'center'
                                        }}>
                                            <i className="fa fa-cogs" style={{ marginRight: '8px', color: '#007bff' }}></i>
                                            Actions
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderProducts()}
                                </tbody>
                            </Table>
                        </div>
                    }
                />

                {/* Pagination */}
                {this.renderPagination()}

                {/* Compteur de résultats */}
                {filtered.length > 0 && (
                    <div style={{
                        textAlign: 'center',
                        marginTop: '25px',
                        padding: '15px',
                        backgroundColor: 'white',
                        borderRadius: '10px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                    }}>
                        <span style={{
                            color: '#495057',
                            fontSize: '14px',
                            fontWeight: '500'
                        }}>
                            <i className="fa fa-chart-bar" style={{ marginRight: '8px', color: '#007bff' }}></i>
                            {filtered.length} produit{filtered.length > 1 ? 's' : ''} affiché{filtered.length > 1 ? 's' : ''}
                            {search && (
                                <span style={{ color: '#6c757d', fontStyle: 'italic' }}>
                                    {' '}pour "{search}"
                                </span>
                            )}
                        </span>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading: state.status?.loading || false,
        message: state.status?.message,
        products: state.local?.products || []
    };
};

const mapDispatchToProps = dispatch => ({
    getLocalProducts: () => dispatch(getLocalProducts()),
    syncProducts: () => dispatch(syncProducts()),
    deleteProduct: prod => dispatch(deleteProduct(prod))
});

Local.propTypes = {
    products: PropTypes.array,
    loading: PropTypes.bool,
    message: PropTypes.object,
    showNotification: PropTypes.func,
    getLocalProducts: PropTypes.func.isRequired,
    syncProducts: PropTypes.func.isRequired,
    deleteProduct: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(Local);
